module.exports = __webpack_public_path__ + "img/logo_svg_dt.54913099.svg";